<template>
    <tbody v-if="showItem" :class="getTbodyClass">
        <template v-if="cart.itemList[itemIndex].type === 'sysconfig'">
            <tr :class="cart.itemList[itemIndex].name">
                    <td width="10%" class="text-center hidden-xs">
                        <img v-if="cart.itemList[itemIndex].systemImage.length && cart.itemList[itemIndex].systemImage[0].image" class="img-responsive" :src="'https://campbellsci-res.cloudinary.com/image/upload/w_50,h_50/' +cart.itemList[itemIndex].systemImage[0].image + '.png'" />
                        <i v-else class="mi csi-iconfont csi-logo"></i>
                    </td>
                    <td width="48%">
                        <div class="cartListItem"  :id="cart.itemList[itemIndex].name">
                            <i v-if="!cart.itemList[itemIndex].sysInfo.prod_purchase" class="text-danger normal csi-iconfont csi-attention"></i>
                            <a :href="'/'+cart.itemList[itemIndex].sysInfo.prod_url">
                                <strong>{{cart.itemList[itemIndex].name}}</strong>
                            </a><br class="hidden-xs">
                            <span class="text-muted hidden-xs">{{cart.itemList[itemIndex].sysInfo.prod_title}}</span><br />
                        </div>
                        <div class="systemListItems" :id="'systemListItems'+cart.itemList[itemIndex].name">
                            <div v-for="(sortedProd, index) in cart.itemList[itemIndex].itemProdsSorted" v-bind:key="index" class="text-muted small">
                                <template v-if="sortedProd.parent">&nbsp;&nbsp;&nbsp;- </template>
                                <strong>{{sortedProd.c_part}}</strong> {{truncate(sortedProd.title, 30)}} ({{sortedProd.quantity}})
                            </div>
                        </div>
                        <div>
                            <small>
                                <a :href="'/'+cart.itemList[itemIndex].sysUrl" rel="nofollow" :title="labels[1344]">{{labels[1001]}}<!-- edit --></a><!-- labels: 1344:Change configuration-->
                                |
                                <a class="cartRemover sysGroup" @click="removeItem(cart.itemList[itemIndex])">{{labels[1002]}}<!-- remove --></a>
                            </small>
                        </div>
                    </td>

                    <td v-if="canSeePrices" width="12%" class="price itemprice" id="cost">
                        <span>{{cart.itemList[itemIndex].itemPrice}}<!--#lsCurrencyFormat((sysPrice / sysQty), "local" , priceLocale())#--></span>
                    </td>
                    <td width="10%" class="qtyBoxVue text-right">
                        <div>
                            <input rel="" type="text" v-model="cart.itemList[itemIndex].mainqty" @keyup="setItemQtyPending" @change="changeQty(cart.itemList[itemIndex], cart.itemList[itemIndex].mainqty)" class="qtyBoxVue text-right sysGroup" size="1" maxlength="4" /><br />
                            <a href="" v-if="pendingQty" @click.prevent="">{{labels[1380]}}</a><!-- label: update -->
                        </div>
                    </td>
                    <td v-if="canSeePrices" width="20%" class="price itemtotalprice ra">
                        {{cart.itemList[itemIndex].totalPrice}}<!--#lsCurrencyFormat(sysPrice, "local" , priceLocale())#-->
                    </td>
                </tr>
        </template>

        <template v-else-if="cart.itemList[itemIndex].type === 'sysBuilder'">
            <tr :class="cart.itemList[itemIndex].name">
                    <td width="10%" class="text-center hidden-xs">
                        <i class="mi csi-iconfont csi-logo"></i>
                    </td>

                    <td width="48%">
                        <div class="cartListItem" :id="cart.itemList[itemIndex].name">
                            <i v-if="!cart.itemList[itemIndex].canPurchaseOnline" class="text-danger normal csi-iconfont csi-attention"></i>
                            <a :href="'/'+pageURLs[829]+'?system='+cart.itemList[itemIndex].name">
                                <strong>{{cart.itemList[itemIndex].name}}</strong>
                            </a>
                        </div>
                        <div class="systemListItems" :id="'systemListItems'+ cart.itemList[itemIndex].name">
                            <div v-for="(sortedProd, index) in cart.itemList[itemIndex].itemProdsSorted" v-bind:key="index" class="text-muted small">
                                <template v-if="sortedProd.parent">&nbsp;&nbsp;&nbsp;- </template>
                                <strong>{{sortedProd.c_part}}</strong> {{truncate(sortedProd.title, 30)}} ({{sortedProd.quantity}})
                            </div>
                        </div>
                        <div>
                            <small>
                                <a :href="'/' + pageURLs[829] + '?system='+ cart.itemList[itemIndex].name" rel="nofollow" :title="labels[1344]">{{labels[1001]}}<!-- edit --></a><!-- labels: 1344:Change configuration-->
                                |
                                <a class="cartRemover" @click="removeItem(cart.itemList[itemIndex])">{{labels[1002]}}<!-- remove --></a>
                            </small>
                        </div>
                    </td>
                    <td v-if="canSeePrices" width="12%" class="price itemprice" id="cost">
                        <span>{{cart.itemList[itemIndex].itemPrice}}</span><!-- #lsCurrencyFormat((sysPrice / sysQty), "local" , priceLocale())# -->
                    </td>
                    <td width="10%" class="qtyBoxVue text-right">
                        <div>
                            <input rel="" type="text" v-model="cart.itemList[itemIndex].mainqty" @keyup="setItemQtyPending" @change="changeQty(cart.itemList[itemIndex], cart.itemList[itemIndex].mainqty)" class="qtyBoxVue text-right sysGroup" size="1" maxlength="4" /><br />
                            <a href="" v-if="pendingQty" @click.prevent="">{{labels[1380]}}</a><!-- label: update -->
                        </div>
                    </td>
                    <td v-if="canSeePrices" width="20%" class="price itemtotalprice ra">
                        {{cart.itemList[itemIndex].totalPrice}}<!--#lsCurrencyFormat(sysPrice, "local" , priceLocale())#-->
                    </td>
                </tr>
        </template>

        <template v-else-if="cart.itemList[itemIndex].type === 'subscription'">
            <tr :class="cart.itemList[itemIndex].name">
                    <td width="10%" class="text-center hidden-xs">
                        <img class="img-responsive" src="https://campbellsci-res.cloudinary.com/image/upload/w_40,h_40/11987.png" />
                        <!-- <img class="img-responsive" src="#cloudImage(11987,40)#" /> -->
                    </td>

                    <td width="70%" colspan="3">
                        <div class="cartListItem"  :id="cart.itemList[itemIndex].name">
                            <i v-if="!cart.itemList[itemIndex].canPurchaseOnline" class="text-danger normal csi-iconfont csi-attention"></i>
                            <a :href="'/'+pageURLs[93]+'?mode=celldata&view=renewals'">
                                <strong>{{cart.itemList[itemIndex].name}}</strong>
                            </a>
                        </div>
                        <table class="table table-condensed subscriptions-table">
                            <tbody>
                                <tr v-for="(product, index) in cart.itemList[itemIndex].products" v-bind:key="index">
                                    <td width="65%" class="text-muted">
                                        {{product.title}}
                                    </td>
                                    <td width="20%" class="price">
                                        <template v-if="canSeePrices">
                                            {{product.priceFormatted}}<!--#lsCurrencyFormat((cart.itemList[itemIndex].price), "local" , priceLocale())#-->
                                        </template>
                                    </td>
                                    <td width="15%" class="text-right">
                                        <input type="text" v-model="product.quantity" @keyup="setItemQtyPending" @change="changeQty(product, product.quantity)" disabled="disabled" class="qtyBoxVue text-right sysGroup" size="1" maxlength="4" />
                                        <a href="" v-if="pendingQty" @click.prevent="">{{labels[1380]}}</a><!-- label: update -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div>
                            <small>
                                <a :href="'/'+pageURLs[93]+'?mode=celldata&view=renewals&selected'">{{labels[1001]}}</a><!-- label:edit -->
                                |
                                <a class="cartRemover" @click="removeItem(cart.itemList[itemIndex])">{{labels[1002]}}</a><!-- label:remove -->
                            </small>
                        </div>
                    </td>
                    <td v-if="canSeePrices" width="20%" class="price itemtotalprice ra">
                        {{cart.itemList[itemIndex].totalPrice}}<!--#lsCurrencyFormat(sysPrice, "local" , priceLocale())#-->
                    </td>
                </tr>
        </template>

        <template v-else><!-- Standard components / single products -->
            <tr :class="cart.itemList[itemIndex].products[0].c_part">
                    <td width="10%" class="text-center hidden-xs">
                        <!-- <img class="img-responsive" src="#cloudImage(cart.itemList[itemIndex].image,50)#" /> -->
                        <img v-if="cart.itemList[itemIndex].products[0].image" class="img-responsive" :src="'https://campbellsci-res.cloudinary.com/image/upload/f_auto,c_limit,w_50,h_50/' + cart.itemList[itemIndex].products[0].image + '.png'" />
                        <i v-else class="mi csi-iconfont csi-logo"></i>
                    </td>
                    <td width="48%">
                        <div class="cartListItem" :id="cart.itemList[itemIndex].products[0].c_part">
                            <i v-if="getRClass === 'no-order-invalid'" class="text-warning normal csi-iconfont csi-attention"></i>
                            <i v-if="getRClass === 'no-order'" class="text-danger normal csi-iconfont csi-attention"></i>
                            <a :href="getItemUrl">
                                <strong>{{cart.itemList[itemIndex].products[0].c_part}}</strong>
                                <span v-if="hasOrderData && cart.itemList[itemIndex].products[0].configurable" class="text-danger">
                                    <strong>*</strong>
                                </span>
                            </a>
                            &nbsp;<span v-if="cart.itemList[itemIndex].products[0].gsa && (cart.reqPricing.toLowerCase() === 'gsa' || cart.reqPricing2.toLowerCase() ==='gsa')" class="label label-primary white" :title="labels[2445]">{{labels[2444]}}</span>
                            <br class="hidden-xs">
                            <span class="text-muted hidden-xs">{{cart.itemList[itemIndex].products[0].title}}</span><br />
                            <small>
                                <template v-if="isEcommerce && cart.itemList[this.itemIndex].products[0].configurable">
                                    <router-link :to="'/edit-cart-item/'+itemIndex" rel="nofollow" class="edit-item-vue">{{labels[1001]}}<!-- edit --></router-link>
                                    |
                                </template>
                                <a class="cartRemoverVue" @click="removeItem(cart.itemList[itemIndex])">{{labels[1002]}}<!-- remove --></a>

                                <template v-if="canOrder && cart.itemList[itemIndex].products[0].qtydiscount">
                                    |
                                    <QtyDiscountLink :item="cart.itemList[itemIndex]" />
                                </template>
                            </small>
                        </div>
                        <div class="cartNoteHolder">
                            <div class="cartNote" :id="'n'+cart.itemList[itemIndex].name" :cid="cart.itemList[itemIndex].name">
                                <template v-if="cart.itemList[itemIndex].products[0].note">
                                    {{cart.itemList[itemIndex].products[0].note}}
                                </template>
                            </div>
                        </div>
                    </td>
                    <td v-if="canSeePrices" width="12%" class="price itemprice" :id="'cost'+cart.itemList[itemIndex].name">
                        <span v-if="!cart.itemList[itemIndex].products[0].special">
                            {{cart.itemList[itemIndex].itemPrice}}<!--#lsCurrencyFormat(cart.itemList[itemIndex].price, "local" , priceLocale())#-->
                        </span>
                        <template v-else>
                            {{labels[1942]}}
                        </template><!-- label: n/a -->
                    </td>
                    <td width="10%" class="qtyboxVue text-right">
                        <div>
                            <input :rel="cart.itemList[itemIndex].name" type="text" v-model="cart.itemList[itemIndex].mainqty" @keyup="setItemQtyPending" @change="changeQty(cart.itemList[itemIndex], cart.itemList[itemIndex].mainqty)" class="qtyBoxVue text-right" size="1" maxlength="4" /><br />
                            <a href="" v-if="pendingQty" @click.prevent="">{{labels[1380]}}</a><!-- label: update -->
                        </div>
                    </td>
                    <td v-if="canSeePrices" width="20%" class="price itemtotalprice ra">
                        <template v-if="!loadingItemPrice">
                            <span v-if="!cart.itemList[itemIndex].products[0].special">
                                {{cart.itemList[itemIndex].totalPrice}}<!--#lsCurrencyFormat((cart.itemList[itemIndex].price * cart.itemList[itemIndex].quantity * topcart.itemList[itemIndex].mainqty), "local" , priceLocale())#-->
                            </span>
                            <template v-else>
                                {{labels[1942]}}
                            </template><!-- label: n/a -->
                        </template>
                        <template v-else>
                            <img src='/layouts/main/styles/images/spinner.gif' />
                        </template>
                    </td>
                </tr>
        </template>
    </tbody>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import useAlerts from '../../shared/composables/useAlerts'
import useCMS from "../../shared/composables/useCMS"
import useUtils from "../../shared/composables/useUtils"
import useCart from "../composables/useCart"
import useCheckout from "../composables/useCheckout"
import QtyDiscountLink from "../components/QtyDiscountLink.vue"

export default {
    name: 'CartItem',
    props: {
        reverseItemIndex: Number //we reverse the array in the cart table, index comes in as the reveresed index
    },
    components: {
        QtyDiscountLink
    },
    setup ({ reverseItemIndex }) {
        const { cart, canOrder, canSeePrices, isEcommerce, hasOrderData, removeItem, updateItemQty } = useCart();
        const { labels, pageURLs } = useCMS();
        const { truncate } = useUtils();
        const { addAlert } = useAlerts();
        const pendingQty = ref(false);
        const loadingItemPrice = ref(false);

        const setItemQtyPending = () => {
            pendingQty.value = true;
        }

        const changeQty = (item, qty) => {
            const { pricing, clearTaxAndShipping } = useCheckout();
            loadingItemPrice.value = true;
            updateItemQty(item, qty).then(
                (resp) => {
                    loadingItemPrice.value = false;
                    //update prices
                    cart.value.pricing.total = Number(resp.data.total.replace(/[^0-9.-]+/g,"")); //Only numbers
                    cart.value.pricing.formattedTotal = resp.data.total;
                    item.itemPrice = resp.data.itembase;
                    item.totalPrice = resp.data.item;
                    pricing.value = cart.value.pricing;
                    clearTaxAndShipping();
                }
            ).catch((error) => {
                loadingItemPrice.value = false;
                addAlert('An error occurred updating item quantity and price.', 'alert-danger', 7000);
                console.log(error);
            });

            pendingQty.value = false;
        }

        //need to get the actual item index in the cart itemList array
        const itemIndex = computed(() => cart.value.itemList.length - 1 - reverseItemIndex);

        return {
            cart,
            canOrder,
            canSeePrices,
            isEcommerce,
            hasOrderData,
            removeItem,
            setItemQtyPending,
            pendingQty,
            changeQty,
            truncate,
            labels,
            pageURLs,
            loadingItemPrice,
            itemIndex
        }
    },
    computed: {
        showItem: function () {
            var type = this.cart.itemList[this.itemIndex].type;
            if (type === 'sysconfig' || type === 'sysBuilder' || type === 'subscription') {
                return true;
            } else if (this.cart.itemList[this.itemIndex].products.length) {
                return true
            } else {
                return false
            }
        },
        getRClass: function() {
            let rClass = '';
            if (this.canOrder && !this.cart.itemList[this.itemIndex].canPurchaseOnline) {
                rClass = "no-order";
            } else if (!this.canOrder && !this.cart.itemList[this.itemIndex].products[0].quote && this.cart.itemList[this.itemIndex].type != 'sysBuilder' && this.cart.itemList[this.itemIndex].type != 'subscription') {
                rClass = "no-quote";
            }
            if (this.cart.itemList[this.itemIndex].invalid) {
                rClass = "no-order-invalid";
            }
            return rClass;
        },
        getTbodyClass: function () {
            let tClass = '';
            switch (this.cart.itemList[this.itemIndex].type) {
                case 'sysconfig':
                    tClass = this.getSysConfigClass;
                    break;
                case 'sysBuilder':
                case 'subscription':
                    tClass = this.getRClass;
                    break;
                default:
            }

            return tClass;
        },
        getItemUrl: function() {
            return this.hasOrderData && !this.cart.itemList[this.itemIndex].products[0].special ? ('/' + this.pageURLs[420] + '/' + this.cart.itemList[this.itemIndex].products[0].url) : ('/' + this.cart.itemList[this.itemIndex].products[0].url);
        },
        getSysConfigClass: function(){
            let sysConfigClass = '';

            if (this.canOrder && !this.cart.itemList[this.itemIndex].sysInfo.prod_purchase){
                sysConfigClass = "no-order";
            }
            if (this.cart.itemList[this.itemIndex].invalid) {
                sysConfigClass = "no-order-invalid";
            }

            return sysConfigClass;
        }
    }
}
</script>
